import { render } from "./Contact.vue?vue&type=template&id=0e1d17d5&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=0e1d17d5&scoped=true&lang=css"

import exportComponent from "/builds/tapetum1/tapetum-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1d17d5"]])

export default __exports__